/* ============================================================
   NIMBUS Orbital Ring — shared physics module (Chunk 6, extracted from the collection ORBIT view).
   FAITHFUL LIFT: the physics/nav/drag/momentum/wheel/idle-drift/CRT-power-on logic is byte-for-byte
   the collection ring's — only the 3 collection-coupled inputs are parameterized:
     • grid card capture      → opts.cards (caller passes the item nodes)
     • view==='orbit' gating  → an internal `active` flag (enter()/leave())
     • RETRO / modeClass()    → moved in-module (generic)
   The collection section now calls NimbusOrbit.mount() and drives its GRID/ORBIT toggle via
   enter()/leave(); the product page [ RELATED UNITS ] ring mounts a 2nd instance (Chunk 6 part 2).
   Behavior is identical to the original collection ORBIT.
   ============================================================ */
(function(){
  var RETRO = {'mode-lisa':1,'mode-classic':1,'mode-crt':1};
  function modeClass(){ return (document.documentElement.className.split(' ').filter(function(x){return x.indexOf('mode-')===0;})[0])||'mode-nimbus'; }

  // mount(orbitEl, { cards:[nodes], titleSelector }) → controller { enter, leave, focus, isActive, cells }
  function mount(orbit, opts){
    opts = opts || {};
    if(!orbit) return null;
    var ringEl = orbit.querySelector('[data-orbit-ring]');
    if(!ringEl) return null;
    var readout = orbit.querySelector('[data-orbit-readout]');
    var dotsWrap = orbit.querySelector('[data-orbit-dots]');
    var stage = orbit.querySelector('[data-orbit-stage]');
    var titleSel = opts.titleSelector || '[data-shopify-bind="title"]';

    var cards = (opts.cards || []).slice();
    var N = cards.length; if(!N) return null;
    var step = 360 / N, focus = 0, active = false, cells = [], dotEls = [], homes = [];
    // ADDITIVE (does not change mount behavior): one AbortController wired into every listener below so
    // destroy() can unbind them all — incl. the GLOBAL document-keydown — in a single abort(). The stored
    // MutationObserver is disconnected the same way. Only the collection ORBIT calls destroy() (to re-mount
    // against AJAX-swapped grid cards); the product-page RELATED UNITS ring never calls it → unaffected.
    var _ac = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var _sig = _ac ? _ac.signal : undefined;   // undefined on ancient browsers → addEventListener ignores it (same as today)
    var _mo = null;

    // build orbit-card wrappers + dots ONCE (empty; the real cards shuttle in/out of the wrappers)
    for(var i=0;i<N;i++){
      var cell = document.createElement('div');
      cell.className = 'orbit-card';
      cell.innerHTML = '<span class="orbit-reticle" aria-hidden="true"><i class="tl"></i><i class="tr"></i><i class="bl"></i><i class="br"></i></span>';
      ringEl.appendChild(cell); cells.push(cell);
      homes.push(cards[i].parentNode);   // original parent — cards restore here on leave() (collection: the grid)
      var dot = document.createElement('button');
      dot.type='button'; dot.className='orbit-dot'; dot.setAttribute('aria-label','Focus unit '+(i+1));
      (function(k){ dot.addEventListener('click', function(){ focusIndex(k); }, {signal:_sig}); })(i);
      if(dotsWrap){ dotsWrap.appendChild(dot); } dotEls.push(dot);
    }

    // FLAT FOCUS OVERLAY (crispness refactor): the focused unit's REAL card node is MOVED here — a flat, 2D layer
    // OUTSIDE the stage's perspective → rendered at native resolution (no GPU texture-upscale), so its text /
    // ADD TO CARGO / image are as crisp as grid view. The 3D ring behind holds the OTHER units as receding photo
    // panels. ONE real node per product (moved, never cloned) → the <product-form> add-to-cargo keeps working with
    // no duplicate form-id hazard. overlayIdx tracks which card currently sits in the overlay (-1 = none).
    var focusOverlay = document.createElement('div');
    focusOverlay.className = 'orbit-focus';
    focusOverlay.innerHTML = '<span class="orbit-reticle" aria-hidden="true"><i class="tl"></i><i class="tr"></i><i class="bl"></i><i class="br"></i></span>';
    if(stage) stage.appendChild(focusOverlay);
    var overlayIdx = -1;
    function parkOverlay(){                                          // return the overlay card to its 3D ring cell
      if(overlayIdx<0) return;
      var i=overlayIdx; overlayIdx=-1;
      if(cards[i] && cells[i]) cells[i].appendChild(cards[i]);
      focusOverlay.classList.remove('on','pwr');
    }
    function liftToOverlay(idx){                                     // MOVE the focused real node onto the flat layer
      parkOverlay();
      overlayIdx = ((idx % N) + N) % N;
      focusOverlay.appendChild(cards[overlayIdx]);
      focusOverlay.classList.add('on');
      if(!reduced() && !RETRO[modeClass()]){                         // CRT power-on wipe on swap (retro/reduced skip)
        focusOverlay.classList.remove('pwr'); void focusOverlay.offsetWidth; focusOverlay.classList.add('pwr');
      }
      sweep(focusOverlay);                                           // scanline sweep (self-gates retro/reduced)
    }

    function reduced(){ return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
    function motionOK(){ return !reduced(); }                       // reduced-motion kills ALL physics (LAW); retro keeps the spin
    function trailOK(){ return !reduced() && !RETRO[modeClass()]; } // faint orbit-path motion trail — NIMBUS/STEALTH/HOLO only (§8/§10)

    var angle = 0, vel = 0, raf = null, driftTimer = null, driftActive = false;
    var dragging = false, inMotion = false, didDrag = false, hovering = false, settling = false, settleTarget = 0;
    var startX = 0, startAngle = 0, lastX = 0, lastT = 0;
    var SENS = .34, FRICTION = .94, SNAP_VEL = .18, VEL_CAP = 6, DRIFT_SPD = .05, DRIFT_DELAY = 4200, DRAG_THRESH = 6, WHEEL_CD = 130, lastWheel = 0;
    function renderRing(){ ringEl.style.transform = 'rotateX(14deg) rotateY('+angle+'deg)'; }
    function angleToIndex(a){ return ((Math.round(-a/step) % N) + N) % N; }
    function snapNearest(a){ return Math.round(a/step) * step; }
    function baseZ(){ return 'var(--orbit-r,480px)'; }
    function flattenCells(){ parkOverlay(); for(var i=0;i<N;i++){ cells[i].classList.remove('is-focus'); cells[i].style.transform='translate(-50%,-50%) rotateY('+(i*step)+'deg) translateZ('+baseZ()+')'; } }   /* parkOverlay: any spin start (drag/drift) returns the crisp focused card to its ring cell so the ring is complete while rotating */
    function setSpinning(on){ if(on && trailOK()) ringEl.classList.add('spinning'); else ringEl.classList.remove('spinning'); }
    function stopMotion(){ if(raf){ cancelAnimationFrame(raf); raf=null; } if(driftTimer){ clearTimeout(driftTimer); driftTimer=null; } driftActive=false; }
    function readoutFor(idx){ if(!readout) return; var t=cards[idx].querySelector(titleSel);
      readout.textContent='// ORBITAL RING · UNIT '+String(idx+1).padStart(2,'0')+' / '+String(N).padStart(2,'0')+' · '+(t?t.textContent.trim():''); }
    function liveReadout(){ readoutFor(angleToIndex(angle)); }

    function sweep(cell){                                            // CRT scanline sweep — NIMBUS/STEALTH/HOLO only
      var old = cell.querySelector('.orbit-sweep'); if(old && old.parentNode) old.parentNode.removeChild(old);
      if(reduced() || RETRO[modeClass()]) return;                   // §8 retro + reduced-motion: no sweep
      var host = cell.querySelector('.nb-scanwrap') || cell;
      var s = document.createElement('div'); s.className='orbit-sweep'; host.appendChild(s);
      s.addEventListener('animationend', function(){ if(s.parentNode) s.parentNode.removeChild(s); });
    }
    function settleVisuals(idx){
      focus = ((idx % N) + N) % N;
      ringEl.style.transition=''; setSpinning(false); renderRing();
      for(var i=0;i<N;i++){                                          // all cells uniform receding photos; no cell is is-focus
        cells[i].classList.remove('is-focus');
        cells[i].style.transform = 'translate(-50%,-50%) rotateY('+(i*step)+'deg) translateZ('+baseZ()+')';
      }
      for(var j=0;j<N;j++) dotEls[j].classList.toggle('on', j===focus);
      readoutFor(focus); liftToOverlay(focus); scheduleDrift();      // focused unit lifts to the flat crisp overlay (+ CRT sweep/power-on inside)
    }
    function focusIndex(n){
      stopMotion(); ringEl.style.transition=''; setSpinning(false);
      var target=((n % N)+N)%N, d=target-focus; d=((d % N)+N)%N; if(d>N/2) d-=N;
      angle -= d*step; settleVisuals(target);
    }

    // ---- Phase 2: motion/physics ----
    // idle-drift runs in ALL modes incl. retro (KAKAROT override of "retro = no ambient motion" — for the orbit
    // ring only). reduced-motion (motionOK) still kills it everywhere. The motion-TRAIL stays retro-off via
    // trailOK() inside setSpinning() — retro drifts but stays flat/mechanical, no glow trail.
    function scheduleDrift(){ if(!motionOK()) return; if(driftTimer) clearTimeout(driftTimer); driftTimer=setTimeout(startDrift, DRIFT_DELAY); }
    function startDrift(){ driftTimer=null; if(!motionOK()||!active||dragging||hovering||raf) return;
      ringEl.style.transition='none'; flattenCells(); setSpinning(true); driftActive=true; raf=requestAnimationFrame(driftFrame); }
    function driftFrame(){ if(!active||dragging||hovering||!motionOK()){ raf=null; driftActive=false; return; }
      angle+=DRIFT_SPD; renderRing(); liveReadout(); raf=requestAnimationFrame(driftFrame); }
    function startMomentum(){ stopMotion(); settling=false; ringEl.style.transition='none'; setSpinning(true); raf=requestAnimationFrame(momentum); }
    function momentum(){
      if(!active||!motionOK()){ stopMotion(); return; }
      if(!settling){ angle+=vel; vel*=FRICTION; liveReadout(); if(Math.abs(vel)<SNAP_VEL){ settling=true; settleTarget=snapNearest(angle); } }
      else { angle+=(settleTarget-angle)*.2; if(Math.abs(settleTarget-angle)<.2){ angle=settleTarget; raf=null; return settleVisuals(angleToIndex(angle)); } }
      renderRing(); raf=requestAnimationFrame(momentum);
    }

    // nav + interaction
    var pv=orbit.querySelector('[data-orbit-prev]'), nx=orbit.querySelector('[data-orbit-next]');
    if(pv) pv.addEventListener('click', function(){ focusIndex(focus-1); }, {signal:_sig});
    if(nx) nx.addEventListener('click', function(){ focusIndex(focus+1); }, {signal:_sig});
    ringEl.addEventListener('click', function(e){
      var cell = e.target.closest('.orbit-card'); if(!cell) return;
      var idx = cells.indexOf(cell); if(idx<0 || idx===focus) return;
      e.preventDefault(); e.stopPropagation(); focusIndex(idx);
    }, {signal:_sig});
    document.addEventListener('keydown', function(e){
      if(!active) return;
      var tag=(e.target.tagName||'').toLowerCase(); if(tag==='input'||tag==='select'||tag==='textarea') return;
      if(e.key==='ArrowLeft'){ e.preventDefault(); focusIndex(focus-1); }
      else if(e.key==='ArrowRight'){ e.preventDefault(); focusIndex(focus+1); }
    }, {signal:_sig});
    if(stage){
      stage.addEventListener('pointerdown', function(e){
        if(!motionOK()) return; if(e.pointerType==='mouse' && e.button!==0) return;
        dragging=true; inMotion=false; didDrag=false; vel=0;
        startX=e.clientX; startAngle=angle; lastX=e.clientX; lastT=e.timeStamp||Date.now(); stopMotion();
      }, {signal:_sig});
      stage.addEventListener('pointermove', function(e){
        if(!dragging) return; var dx=e.clientX-startX;
        if(!inMotion){ if(Math.abs(dx)<DRAG_THRESH) return; inMotion=true; didDrag=true; ringEl.style.transition='none'; flattenCells(); setSpinning(true);
          try{ stage.setPointerCapture(e.pointerId); }catch(_){} }
        angle=startAngle+dx*SENS; renderRing(); liveReadout();
        var now=e.timeStamp||Date.now(), dt=Math.max(1, now-lastT);
        vel=Math.max(-VEL_CAP, Math.min(VEL_CAP, (e.clientX-lastX)*SENS*(16.67/dt))); lastX=e.clientX; lastT=now;
      }, {signal:_sig});
      var endDrag=function(e){ if(!dragging) return; dragging=false; try{ stage.releasePointerCapture(e.pointerId);}catch(_){}
        if(didDrag) startMomentum(); else scheduleDrift(); };
      stage.addEventListener('pointerup', endDrag, {signal:_sig});
      stage.addEventListener('pointercancel', endDrag, {signal:_sig});
      stage.addEventListener('click', function(e){ if(didDrag){ e.stopPropagation(); e.preventDefault(); didDrag=false; } }, {capture:true, signal:_sig});
      stage.addEventListener('wheel', function(e){
        if(!motionOK()) return; e.preventDefault();
        var now=e.timeStamp||Date.now();
        if(now - lastWheel < WHEEL_CD) return; lastWheel = now;
        focusIndex(focus + (e.deltaY>0 ? 1 : -1));
      }, {passive:false, signal:_sig});
      stage.addEventListener('mouseenter', function(){ hovering=true; if(driftActive){ stopMotion(); angle=snapNearest(angle); settleVisuals(angleToIndex(angle)); } }, {signal:_sig});
      stage.addEventListener('mouseleave', function(){ hovering=false; scheduleDrift(); }, {signal:_sig});
    }

    // ---- OS mode change (Bug 2): if the mode-* class on <html> flips while the ring is live, CANCEL any
    //      running idle-drift / momentum / rAF and RE-SETTLE to a clean centered focus. Without this, switching
    //      to a retro mode mid idle-drift froze the ring in its flattened, non-snapped state (no card centered
    //      → focused card off-screen/broken). snapNearest + settleVisuals(angleToIndex) is the same clean re-settle
    //      the drift-interrupt (mouseenter) uses. Works regardless of the mode switched to/from; only fires on an
    //      actual mode change, only when active — never touches normal drag/nav/wheel/toggle flow. Same
    //      MutationObserver(class) pattern the collection section uses for its headline relock.
    if(window.MutationObserver){
      var lastMode = modeClass();
      _mo = new MutationObserver(function(){
        var m = modeClass(); if(m===lastMode) return; lastMode=m;   // only react to a real mode-* change
        if(!active) return;                                          // ring not shown → nothing to re-settle
        stopMotion(); angle = snapNearest(angle); settleVisuals(angleToIndex(angle));
      });
      _mo.observe(document.documentElement, { attributes:true, attributeFilter:['class'] });
    }

    // ---- controller: enter() moves cards into the ring + activates; leave() stops + restores cards ----
    function enter(){ if(active) return; for(var i=0;i<N;i++) cells[i].appendChild(cards[i]); active=true; focusIndex(focus); }
    function leave(){ if(!active) return; stopMotion(); dragging=false; setSpinning(false); active=false;
      parkOverlay(); focusOverlay.classList.remove('on','pwr');      // clear the overlay before restoring cards to the grid
      for(var i=0;i<N;i++){ if(homes[i]) homes[i].appendChild(cards[i]); } }
    // ADDITIVE: full teardown so the caller can re-mount against a fresh card set (AJAX filter). Returns the
    // real card nodes to their home parents, aborts every listener bound above (incl. global keydown),
    // disconnects the mode observer, and removes the orbit-card wrappers + dots this mount created. Idempotent.
    function destroy(){
      leave();                                                       // return live cards to their grid homes + stop motion
      stopMotion();
      if(_ac){ try{ _ac.abort(); }catch(_){} }                        // unbind pv/nx/ring/keydown/stage/wheel/dots
      if(_mo){ try{ _mo.disconnect(); }catch(_){} _mo=null; }
      for(var i=0;i<N;i++){
        if(cells[i] && cells[i].parentNode) cells[i].parentNode.removeChild(cells[i]);
        if(dotEls[i] && dotEls[i].parentNode) dotEls[i].parentNode.removeChild(dotEls[i]);
      }
      if(focusOverlay && focusOverlay.parentNode) focusOverlay.parentNode.removeChild(focusOverlay);   // remove the flat overlay this mount created
    }
    return { enter:enter, leave:leave, focus:focusIndex, isActive:function(){ return active; }, cells:cells, destroy:destroy };
  }

  window.NimbusOrbit = { mount: mount };
})();
